<template>
    <div class="bio-drop-down-container">
        <div class="bio-drop-down" :class="{ disabled }">
            <div class="b-dd_label"
                 @click.stop="toggleDropdown">
            <span class="for-active-search" @click="onActiveSearch">
                <div class="label-container">
                    <div class="label-container__label">
                        {{ isShowSelectLabel ? 'Selected: ' : '' }}{{ selected.label }}
                    </div>
                    <div v-if="selected.labelType" class="label-container__tag">{{ selected.labelType }}</div>
                </div>
            </span>
                <PtIcon v-if="!showList" icon="SolidArrowDown"/>
                <PtIcon v-else icon="SolidArrowUp"/>
                <input ref="searchInput"
                       v-if="supportSearch && searchActived" type="text"
                       class="b-dd_search-input"
                       v-model="searchWord"
                       @input="onSearch">
            </div>
            <div v-show="showList">
                <div class="b-dd_list" ref="list">
                    <template v-for="(group, index) in _dataPages">
                        <!-- label -->
                        <div class="group_label"
                             :key="`label_${index}`"
                             v-if="group.label && group.label !== 'Upload'">
                            {{ group.label }}
                        </div>
                        <!-- query 区域 不用加载 -->
                        <section :class="{ 'observe-item': index === selectedDataIndex }"
                                 :style="{ height: `${32*page.length}px` }"
                                 :data-page="pageIndex"
                                 :data-has-load="checkPageLoaded(page)"
                                 v-for="(page, pageIndex) in group.data"
                                 :key="`${page.key}_${pageIndex}`">
                            <!-- 分组的情况下 group 1 -->
                            <div v-if="isGroup && index !== selectedDataIndex"
                                 class="list-item label-container"
                                 :class="{ selected: selected.key === page.key }"
                                 :key="`code_${index}_${pageIndex}`"
                                 :title="page.label"
                                 @click="onSelect(page)">
                                <div class="label-container__label">{{ page.label }}</div>

                                <div v-if="page.labelType" class="label-container__tag">{{ page.labelType }}</div>
                            </div>
                            <!-- 分组的情况下 group 从1开始渲染；没有分组直接从0开始渲染 -->
                            <template v-if="index === selectedDataIndex && isActivePage(pageIndex)">
                                <div
                                    class="list-item"
                                    v-for="(item, idx) in page"
                                    :key="`code_${index}_${pageIndex}_${idx}`"
                                    :class="{ selected: selected.key === item.key }"
                                    :title="item.label"
                                    @click="onSelect(item)">
                                    {{ item.label }}
                                </div>
                            </template>
                        </section>
                    </template>
                </div>
            </div>
            <!-- 搜索结果列表 -->
            <div v-if="supportSearch" v-show="searchActived && searchResults.length">
                <div class="b-dd_list " ref="searchList">
                    <section class="observe-search-list"
                             :key="`code_${chunkIndex}`"
                             :data-page="chunkIndex"
                             :style="{ height: `${32*arr.length}px` }"
                             v-for="(arr, chunkIndex) in searchResultsChunks">
                        <template v-if="chunkIndex <= activedSearchPage + 1 && chunkIndex >= activedSearchPage - 1">
                            <div class="list-item"
                                 :key="`code_${chunkIndex}_${idx}`"
                                 @click="onSelect(item)"
                                 v-for="(item, idx) in arr">
                                {{ item.label }}
                            </div>
                        </template>
                    </section>
                </div>
            </div>
        </div>
        <span class="bio-drop-down__switch" v-if="!hideSwitch">
        <span class="bio-drop-down__switch--pre" :class="{ disabled: previousDisabled }">
            <PtIcon icon="SolidArrowTailUp" :style="{fill:previousDisabled ? '#B3BAC5' : '#505F79'}"
                    @click="onPrevious"></PtIcon>
        </span>
        <span class="bio-drop-down__switch--next" :class="{ disabled: nextDisabled }">
            <PtIcon icon="SolidArrowTailDown" :style="{fill:nextDisabled ? '#B3BAC5' : '#505F79'}"
                    @click="onNext"></PtIcon>
        </span>
    </span>
    </div>
</template>

<script>
import { icon } from 'patsnap-biz';
import findIndex from 'lodash/findIndex';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import chunk from 'lodash/chunk';
import { SEQUENCE_PAGE_SIZE } from '@/constants';
import '@patsnap-ui/icon/assets/solid/ArrowDown.svg';
import '@patsnap-ui/icon/assets/solid/ArrowUp.svg';
import '@patsnap-ui/icon/assets/solid/ArrowTailUp.svg';
import '@patsnap-ui/icon/assets/solid/ArrowTailDown.svg';

const PAGE_SIZE = SEQUENCE_PAGE_SIZE;

const initObserve = (observeElements, intersectCallBack, correctCurrentPage) => {
    const intersectionObserver = new IntersectionObserver(function (entries) {
        // If intersectionRatio is 0, the target is out of view
        // and we do not need to do anything.
        // if (entries[0].intersectionRatio <= 0) return;
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const elem = entry.target;
                intersectCallBack && intersectCallBack(elem);
            }
        });
        // 获取当前滚动条高度 计算页数
        correctCurrentPage && correctCurrentPage();
    });
    // start observing
    forEach(observeElements, v => {
        intersectionObserver.observe(v);
    });
    return intersectionObserver;
};

export default {
    data() {
        return {
            selected: '',
            selectIndex: -1,
            showList: false,
            searchWord: '',
            searchResults: [],
            searchActived: false,
            currentPage: 0,
            activedSearchPage: 0,
        };
    },
    props: {
        type: {
            type: String,
            default: 'normal'
        },
        dataSet: {
            type: Array,
            required: true
        },
        defaultSelected: {
            type: Object,
            required: false
        },
        supportSearch: {
            type: Boolean,
            required: false,
        },
        loadDataFn: {
            type: Function,
            default: () => {}
        },
        isLazyLoadData: {
            type: Boolean,
            default: false
        },
        hideSwitch: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            disabled: false
        }
    },
    components: {
        PtIcon: icon
    },
    computed: {
        _dataSet() {
            if (this.type === 'group') {
                return this.dataSet;
            }
            return [
                {
                    label: '',
                    data: this.dataSet
                }
            ];
        },
        // 读数据分页
        _dataPages() {
            let _dataset = [];
            if (this.type === 'group') {
                const selectedSequenceData = get(this.dataSet, `[${this.selectedDataIndex}].data`, []);
                const pagesDataSet = chunk(selectedSequenceData, PAGE_SIZE);
                _dataset = [
                    ...this.dataSet.slice(0, this.selectedDataIndex),
                    this.uploadData && {
                        label: '',
                        data: this.uploadData.data
                    },
                    {
                        data: pagesDataSet,
                        label: this.dataSet[this.selectedDataIndex].label,
                    }
                ].filter(Boolean);
            } else {
                const pagesDataSet = chunk(this.dataSet, PAGE_SIZE);
                _dataset = [
                    {
                        data: pagesDataSet,
                        label: '',
                    }
                ];
            }
            return _dataset;
        },
        _planeDataSet() {
            let arr = [];
            this._dataSet.forEach(v => {
                arr = arr.concat(v.data);
            });
            return arr;
        },
        previousDisabled() {
            return this.selectIndex === 0;
        },
        nextDisabled() {
            return this.selectIndex === this._planeDataSet.length - 1;
        },
        isGroup() {
            return this.type === 'group';
        },
        uploadData() {
            return this.dataSet.find(item => item.label.indexOf('Upload') !== -1);
        },
        selectedDataIndex() {
            if (this.isGroup) {
                return this.dataSet.length - 1;
            }
            return 0;
        },
        searchResultsChunks() {
            return chunk(this.searchResults, PAGE_SIZE);
        },
        isShowSelectLabel() {
            return this.type === 'group' && this.selected.label?.indexOf('Query') === -1 && this.selected.label?.indexOf('Upload') === -1;
        }
    },
    methods: {
        toggleDropdown() {
            if (this.disabled) {
                return false;
            }
            this.showList = !this.showList;
            if (this.showList) {
                $(document)
                    .one('click', () => {
                        this.showList = false;
                    });
            }
            this.searchActived = false;
        },
        onSelect(item) {
            this.selected = item;
            // 使用唯一的key
            this.selectIndex = findIndex(this._planeDataSet, x => x.key === item.key);
            this.$emit('select', item);
            this.searchActived = false;
        },
        async onPrevious() {
            if (this.selectIndex > 0) {
                const item = this._planeDataSet[this.selectIndex - 1];
                // 如果当前项目是空的先加载当前页
                const details = await this.checkAndLoadData(item);
                if (details) {
                    const seqDetail = details[item.seqId];
                    item.value = seqDetail.sequence;
                    item.label = seqDetail.sequence;
                }
                this.onSelect(item);
            }
        },
        async onNext() {
            if (this.selectIndex < this._planeDataSet.length - 1) {
                const item = this._planeDataSet[this.selectIndex + 1];
                const details = await this.checkAndLoadData(item);
                if (details) {
                    const seqDetail = details[item.seqId];
                    item.value = seqDetail.sequence;
                    item.label = seqDetail.sequence;
                }
                this.onSelect(item);
            }
        },
        async checkAndLoadData(item) {
            // 如果当前项目是空的先加载当前页
            if (!item.value) {
                const page = get(this._dataPages, `[${this.selectedDataIndex}].data`, [])
                    .find(v => v.find(x => x.seqId === item.seqId));
                const seqIds = page.map(a => ({ seqId: a.seqHashId }));
                return this.loadDataFn(seqIds);
            }
        },
        onActiveSearch(e) {
            if (!this.supportSearch) {
                return;
            }
            e.stopPropagation();
            this.searchActived = true;
            this.showList = false;
            this.activedSearchResult = 0;
            if (!this.searchWord) {
                this.$set(this, 'searchResults', this._planeDataSet);
            }
            this.$nextTick(() => {
                this.$refs.searchInput.focus();
                this.initLazySearchList();
            });
            $(document)
                .one('click', (e) => {
                    if (e.target === this.$refs.searchInput ||
                        (this.$refs.searchList && this.$refs.searchList.contains(e.target))
                    ) {
                        return;
                    }
                    this.searchActived = false;
                });
        },
        onSearch() {
            const word = this.searchWord;
            const results = [];
            this._planeDataSet.forEach(v => {
                if (v.label && v.label.indexOf(word) !== -1) {
                    results.push(v);
                }
            });
            this.$set(this, 'searchResults', results);
            this.$nextTick(() => {
                this.initLazySearchList();
            });
        },
        // 注册懒加载
        initLazy() {
            const _this = this;
            this.intersectionObserver = initObserve(this.$refs.list.querySelectorAll('.observe-item'),
                (elem) => {
                    let page = elem.getAttribute('data-page');
                    _this.currentPage = parseInt(page);
                    let isHasData = elem.getAttribute('data-has-load');
                    if (!isHasData) {
                        const pageData = get(_this._dataPages, `[${this.selectedDataIndex}].data.${page}`, []);
                        const seqIds = pageData.map(v => ({ seqId: v.seqHashId }));
                        _this.loadDataFn(seqIds);
                    }
                }, () => {
                    // 获取当前滚动条高度 计算页数
                    _this.$nextTick(() => {
                        const scrollTop = get(_this.$refs, 'list.scrollTop');
                        if (scrollTop === undefined) {
                            return;
                        }
                        const page = parseInt(scrollTop / (32 * PAGE_SIZE));
                        if (page !== _this.currentPage) {
                            this.currentPage = page;
                        }
                    });
                });
        },
        initLazySearchList() {
            const _this = this;
            if (this.searchOberver) {
                this.searchOberver.disconnect();
            }
            this.searchOberver = initObserve(this.$refs.searchList.querySelectorAll('.observe-search-list'),
                (elem) => {
                    let page = elem.getAttribute('data-page');
                    _this.activedSearchPage = parseInt(page);
                }, () => {
                    // 获取当前滚动条高度 计算页数
                    _this.$nextTick(() => {
                        const scrollTop = get(_this.$refs, 'searchList.scrollTop');
                        if (scrollTop === undefined) {
                            return;
                        }
                        const page = parseInt(scrollTop / (32 * PAGE_SIZE));
                        if (page !== _this.currentPage) {
                            this.activedSearchPage = page;
                        }
                    });
                });
        },
        checkPageLoaded(page) {
            // 抽查第一个代表完成
            const item = get(page, '[0]', {});
            return !!item.value;
        },
        isActivePage(page) {
            return page >= this.currentPage - 1 && page <= this.currentPage + 1;
        },
        initData() {
            this.selected = this.defaultSelected || this.dataSet[0];
            const {
                value,
                label
            } = this.selected;
            this.selectIndex = findIndex(this._planeDataSet, x => {
                if (label.indexOf('Upload') !== -1) {
                    return x.value === value && x.label.indexOf('Upload') !== -1;
                }
                return x.value === value;
            });
        },
        clearData() {
            this.selected = '';
            this.selectIndex = -1;
        }
    },
    created() {
        this.initData();
    },
    watch: {
        defaultSelected(newVal) {
            if (!newVal) {
                return this.clearData();
            }
            this.initData();
        }
    },
    mounted() {
        if (this.isLazyLoadData) {
            this.initLazy();
        }
    },
    beforeDestroy() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
        }
        if (this.searchOberver) {
            this.searchOberver.disconnect();
        }
    }
};
</script>

<style lang="scss">
.bio-drop-down {
    &.disabled {
        cursor: not-allowed;
    }
}

.bio-drop-down-container {
    display: inline-block;
}

.bio-drop-down__switch {
    vertical-align: top;
    height: 32px;
    display: inline-block;

    .patsnap-biz-icon {
        cursor: pointer;
    }

    .bio-drop-down__switch--pre, .bio-drop-down__switch--next {
        display: inline-block;
        width: 32px;
        height: 32px;
        border: 1px solid $neutral-blue-60;
        text-align: center;
        float: left;

        &:hover {
            background: $neutral-blue-30;
        }

        .patsnap-biz-icon {
            font-size: 20px;
        }
    }

    .bio-drop-down__switch--pre {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;

        &.disabled {
            border-color: $neutral-blue-30 transparent $neutral-blue-30 $neutral-blue-30;
            background: #F4F5F7;

            .patsnap-biz-icon {
                cursor: not-allowed;
            }
        }
    }

    .bio-drop-down__switch--next {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        margin-left: -1px;

        &.disabled {
            border-color: $neutral-blue-30 $neutral-blue-30 $neutral-blue-30 transparent;
            background: #F4F5F7;
            margin-left: 0;

            .patsnap-biz-icon {
                cursor: not-allowed;
            }
        }
    }
}

.label-container {
    display: flex;
    align-items: center;

    &__label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &__tag {
        height: 20px;
        display: flex;
        align-items: center;
        border-radius: 4px;
        font-size: 12px;
        background-color: #F4F5F7;
        color: #495973;
        padding: 2px 8px 2px 8px;
    }
}

.bio-drop-down {
    position: relative;
    background-color: #ffffff;
    border: solid 1px #d2d2d2;
    border-radius: 4px;
    display: inline-block;
    width: 180px;
    height: 32px;
    cursor: pointer;
    font-size: 14px;
    text-align: left;

    .b-dd_label {
        position: relative;
        height: 32px;
        line-height: 32px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 25px;
        position: relative;

        .patsnap-biz-icon {
            position: absolute;
            right: 4px;
            top: 7px;
            font-size: 16px;
        }

        .for-active-search {
            width: 140px;
            display: inline-block;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
    }

    .b-dd_search-input {
        position: absolute;
        top: 0px;
        left: 6px;
        display: block;
        height: 30px;
        border: none;
        background: #fff;
        padding: 0;
        font-size: 12px;
        width: 150px;
    }

    .b-dd_list {
        position: absolute;
        width: 100%;
        top: 32px;
        max-height: 170px;
        overflow-y: auto;
        border: solid 1px #d2d2d2;
        background-color: #fff;
        z-index: 3000;
        border-radius: 4px;

        .list-item {
            padding: 0 10px;
            height: 32px;
            line-height: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
                background: #ecf5ff;
            }

            &.selected {
                color: #1976D2;
            }
        }

        .group_label {
            line-height: 28px;
            height: 28px;
            border-bottom: 1px solid #EBECF0;
            margin-right: 10px;
            margin-left: 10px;
            color: #061632;
            font-size: 12px;
            font-style: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
